module.exports = __webpack_public_path__ + "static/media/burger.b909ba45.svg";